import React from "react";
export default function CustomTableEmptyRecord({ columnsCount }) {
  return (
        <div style={{marginTop:"15px"}}>
         <center style={{backgroundColor:"#1B3E6F29",height:"30px",}}>No Record Found!</center>
        </div>
  );
}
